/**
 * Bugherd height fix to help keep elements in place.
 * We add it conditionally because setting height to auto breaks the sticky footer.
 * A setInterval function is used to check for when the bugherd script runs. If after
 * eight attempts the code clears the interval and gives up.
 */

const locations = [
	'http://globus-portal.local',
	'https://globus-portal.local',
	'http://emglobusp.wpengine.com',
	'https://emglobusp.wpengine.com',
];

// Check for bugherd based on urls.
locations.map((location) => {
	let count = 0;
	const maxCount = 8;
	if (window.location.origin === location) {
		const check = setInterval(() => {
			count++;
			const bugherdIframe = document.querySelectorAll('iframe[name="_BH_frame"]');

			// Handle finding the bugherd iframe.
			if (bugherdIframe.length) {
				document.querySelector('html').style.height = 'auto';
				clearInterval(check);
				console.log('Bugherd Found.');
			}

			// We max out the interval as to not keep it looping.
			if (count === maxCount) {
				clearInterval(check);
			}
		}, 2000);
	}
	return true;
});
